import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DMI_CONFIG = defineFcm('dmi_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				showInferredDecisionMakers: { type: 'boolean' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-capybara',
		scope: 'petition-service',
		context: 'Decision Maker Intelligence (DMI)',
		description:
			'Configuration for the Decision Maker Intelligence feature in petition_service, controlling whether DMI is enabled and whether inferred decision makers are shown.',
		import: false,
		template: { enabled: true, showInferredDecisionMakers: true },
	});
